import { StateNode } from '@ansys-internal/awf-angular/store';

export class SelectedRequirementState implements StateNode<string[]> {
  key: string = 'selectedRequirement';
  mutable: boolean = true;
  observeInitial: boolean = true;
  defaultValue: () => string[] = () => [];
}
